// Tooltip style constants
export const TOOLTIP_STYLES = {
  backgroundColor: '#333',
  color: '#fff',
  padding: '8px 12px',
  borderRadius: '4px',
  fontSize: '14px',
  whiteSpace: 'nowrap',
  wordWrap: 'break-word',
  position: 'absolute',
  zIndex: 1100,
  visibility: 'hidden',
  opacity: '0',
  transition: 'opacity 100ms ease-in',
  pointerEvents: 'none',
  overflow: 'visible', // Ensure arrow is not clipped
} as const;

// CSS class names
export const CSS_CLASSES = {
  tooltipBox: 'tippy-box',
  tooltipContent: 'tippy-content',
  trimbleTooltip: 'trimble-tooltip',
  tooltipArrow: 'tippy-arrow',
} as const;

// Default tooltip theme
export const DEFAULT_THEME = 'light';

// Arrow styles for different positions
export const ARROW_STYLES = {
  base: {
    position: 'absolute',
    width: '0',
    height: '0',
    pointerEvents: 'none',
    zIndex: 1099,
  } as const,
  top: {
    bottom: '-5px', // Slightly overlap tooltip
    left: '50%',
    transform: 'translateX(-50%)',
    borderLeft: '6px solid transparent',
    borderRight: '6px solid transparent',
    borderTop: '6px solid #333',
    marginLeft: '-6px', // Center properly
  } as const,
  bottom: {
    top: '-5px', // Slightly overlap tooltip
    left: '50%',
    transform: 'translateX(-50%)',
    borderLeft: '6px solid transparent',
    borderRight: '6px solid transparent',
    borderBottom: '6px solid #333',
    marginLeft: '-6px', // Center properly
  } as const,
  left: {
    right: '-5px', // Slightly overlap tooltip
    top: '50%',
    transform: 'translateY(-50%)',
    borderTop: '6px solid transparent',
    borderBottom: '6px solid transparent',
    borderLeft: '6px solid #333',
    marginTop: '-6px', // Center properly
  } as const,
  right: {
    left: '-5px', // Slightly overlap tooltip
    top: '50%',
    transform: 'translateY(-50%)',
    borderTop: '6px solid transparent',
    borderBottom: '6px solid transparent',
    borderRight: '6px solid #333',
    marginTop: '-6px', // Center properly
  } as const,
} as const;
